import transliterate from "./transliterate";

export const normalizeProductSlug = (value = "") => {
  return String(value)
    .trim()
    .replace(/^https?:\/\/[^/]+/i, "") // якщо раптом вставили повний URL
    .replace(/^\/+/, "") // прибрати слеші зліва
    .replace(/\/+$/, "") // прибрати слеші справа
    .replace(/^product\//, ""); // якщо раптом зберегли product/slug
};

export const getProductSlug = (product) => {
  const customSlug = normalizeProductSlug(product?.url || "");
  if (customSlug) return customSlug;

  return transliterate(product?.bookName || "");
};

export const getProductHref = (product) => {
  return `/product/${getProductSlug(product)}`;
};

export const isProductMatchBySlug = (product, slug) => {
  const normalizedSlug = normalizeProductSlug(slug);
  const byUrl = normalizeProductSlug(product?.url || "");
  const byName = transliterate(product?.bookName || "");

  return normalizedSlug === byUrl || normalizedSlug === byName;
};
